<div class="product-hero" #productsHero data-section-id="products-hero-section" data-section-name="Products Hero">
  <div class="product-hero__content ocultarMobile">
    <img src="https://www.unipay.cl/api/descargaArchivo/banner3-productos-xl.png" alt="Productos Unipay"
      class="product-hero__image ocultarMobile" />
  </div>
  <div class="product-hero__content ocultarDesktop">
    <img src="https://www.unipay.cl/api/descargaArchivo/banner3-productos-movil.png"
      alt="Productos Unipay Movil" class="product-hero__image" />
  </div>
</div>
